export const objFilter = (obj) => 
    Object.keys(obj)
          .filter( key => obj[key] || obj[key] === 0 || obj[key] === false )
          .reduce( (res, key) => (res[key] = obj[key], res), {} );


export function debounce(func, wait, immediate) {
    let timeout;

    return function executedFunction(...args) {
        const context = this;

        const later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const getInitials = (fio) => {
    const [lastName, firstName, fathersname] = fio.split(' ');
    const fiNInitial = firstName ? `${firstName[0]}.` : '';
    const faNInitial = fathersname ? `${fathersname[0]}.` : '';
    return `${lastName} ${fiNInitial} ${faNInitial}`
}